import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hero", "thumb", "counter"]
  static values = { index: Number, urls: Array }

  connect() {
    this.sync()
  }

  select(event) {
    this.indexValue = event.params.index
  }

  prev() {
    this.step(-1)
  }

  next() {
    this.step(1)
  }

  step(delta) {
    const count = this.urlsValue.length
    if (count <= 1) return

    this.indexValue = (this.indexValue + delta + count) % count
  }

  indexValueChanged() {
    this.sync()
  }

  sync() {
    if (!this.hasHeroTarget || this.urlsValue.length === 0) return

    const index = Math.min(this.indexValue, this.urlsValue.length - 1)
    this.heroTarget.src = this.urlsValue[index]

    this.thumbTargets.forEach((thumb, i) => {
      thumb.classList.toggle("listing-hero__thumb-btn--active", i === index)
      thumb.setAttribute("aria-current", i === index ? "true" : "false")
    })

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${index + 1} / ${this.urlsValue.length}`
    }
  }
}
